const pagesIndividualLookupResourcesEn = {
  accounts: {
    detail: {
      account: 'Account',
      app: 'App',
      basicInfo: 'Basic information',
      createdAt: 'Created',
      displayName: 'Display name',
      holder: 'Holder',
      lastSignIn: 'Last sign-in',
      mfa: 'MFA',
      role: 'Role'
    },
    headers: {
      account: 'Account',
      app: 'App',
      createdAt: 'Created',
      displayName: 'Display name',
      lastSignIn: 'Last sign-in',
      mfa: 'MFA',
      role: 'Role'
    },
    mfa: {
      disabled: 'Off',
      enabled: 'On'
    },
    tabs: {
      all: 'All',
      self: 'My accounts'
    },
    title: 'Software'
  },
  certifications: {
    detail: {
      basicInfo: 'Basic information',
      expireAt: 'Valid until',
      holder: 'Holder',
      issuer: 'Issuer',
      lastUpdated: 'Last updated',
      note: 'Notes',
      number: 'Certificate No.',
      renewBy: 'Renew by'
    },
    headers: {
      expireAt: 'Valid until',
      holder: 'Holder',
      lastUpdated: 'Last updated',
      name: 'Certification',
      number: 'Certificate No.',
      renewBy: 'Renew by'
    },
    tabs: {
      all: 'All',
      self: 'My certifications'
    },
    title: 'Certifications'
  },
  common: {
    backToList: 'Back to list',
    backToLookup: 'Back to Inquiry & Reference',
    empty: 'No items to display',
    filterTabsLabel: 'Filter',
    loading: 'Loading…',
    search: 'Search'
  },
  devices: {
    detail: {
      assetTag: 'Asset tag',
      basicInfo: 'Basic information',
      category: 'Type',
      holder: 'Assigned to',
      installPlace: 'Installed at',
      os: 'OS',
      purchasedAt: 'Purchased on',
      serialNumber: 'Serial number',
      status: 'Status',
      storagePlace: 'Stored at'
    },
    headers: {
      assetTag: 'Asset tag',
      category: 'Type',
      holder: 'Assigned to',
      installPlace: 'Installed at',
      name: 'Device',
      status: 'Status',
      storagePlace: 'Stored at'
    },
    status: {
      assigned: 'Assigned',
      installed: 'Installed'
    },
    tabs: {
      all: 'All',
      managed: 'At places I manage',
      self: 'My devices'
    },
    title: 'Devices'
  },
  equipments: {
    detail: {
      assetTag: 'Asset tag',
      basicInfo: 'Basic information',
      category: 'Category',
      holder: 'Assigned to',
      note: 'Notes',
      place: 'Location',
      purchasedAt: 'Purchased on',
      status: 'Status'
    },
    headers: {
      assetTag: 'Asset tag',
      category: 'Category',
      holder: 'Assigned to',
      name: 'Equipment',
      place: 'Location',
      status: 'Status'
    },
    status: {
      assigned: 'Assigned',
      placed: 'Placed at site'
    },
    tabs: {
      all: 'All',
      managed: 'At places I manage',
      self: 'My equipment'
    },
    title: 'Equipment'
  },
  places: {
    detail: {
      address: 'Address',
      basicInfo: 'Basic information',
      devicesTab: 'Devices',
      equipmentsTab: 'Equipment',
      manager: 'Manager'
    },
    headers: {
      address: 'Address',
      deviceCount: 'Devices',
      equipmentCount: 'Equipment',
      manager: 'Manager',
      name: 'Place'
    },
    tabs: {
      all: 'All',
      managed: 'Places I manage'
    },
    title: 'Places'
  }
};
export default pagesIndividualLookupResourcesEn;